import CategoryHorizontalList, {
  CategoryHorizontalListProps
} from '../../../../components/CategoryHorizontalList';
import { ScreenComponentPlugin } from '../ScreenComponentPlugin';

export const CategoryHorizontalListPlugin: ScreenComponentPlugin<CategoryHorizontalListProps> =
  {
    type: 'CategoryHorizontalList',
    name: 'Category Horizontal List',
    categories: ['join'],
    component: CategoryHorizontalList
  };
